<template>
  <v-row class="custom-content-container pt-0">
    <v-col md="12">
      <v-hover v-slot="{ hover }">
        <div class="p-10 text-center">
          <v-progress-circular
            indeterminate
            :size="100"
            :width="10"
            color="cyan"
            v-if="primaryLoader"
          ></v-progress-circular>
          <v-avatar size="140" v-else>
            <v-img
              max-height="140px"
              max-width="140px"
              :lazy-src="$defaultProfileImage"
              :src="getProfileImage ? getProfileImage : $defaultProfileImage"
              class="custom-grey-border margin-auto custom-border-radius-50"
            >
            </v-img>
          </v-avatar>
          <template v-if="getPermission('engineer:update')">
            <div v-if="hover" class="engineer-image-action">
              <v-btn
                depressed
                class="mx-4 custom-bold-button"
                outlined
                small
                :disabled="primaryLoader"
                :loading="primaryLoader"
                v-on:click="selectImage"
                color="cyan"
              >
                <template v-if="getProfileImage">Change Image</template>
                <template v-else>Upload Image</template>
              </v-btn>
              <div class="d-none">
                <v-file-input
                  v-model.trim="rawImage"
                  ref="uploadImage"
                  :rules="imageRules"
                  accept="image/png, image/jpeg, image/bmp"
                ></v-file-input>
              </div>
            </div>
          </template>
        </div>
      </v-hover>
    </v-col>
    <v-col cols="12" class="pa-0">
      <div class="pa-3">
        <table class="width-100">
          <tr>
            <th
              colspan="2"
              class="grey lighten-4 font-size-16 color-custom-blue py-1"
            >
              Technician Information
            </th>
          </tr>
          <tr>
            <td
              style="width: 110px"
              class="py-1 font-size-18 text-capitalize font-weight-500"
            >
              Technician #
            </td>
            <td class="py-1 font-size-18 text-capitalize">
              <template v-if="getBarcode">
                <Barcode :barcode="getBarcode"></Barcode>
                <v-chip
                  label
                  outlined
                  text-color=""
                  style="height: 25px !important"
                  dense
                  class="ml-1"
                  color="red"
                  v-if="getProvision() >= 0"
                  >Probation</v-chip
                >
              </template>
              <em v-else class="text-muted">no Technician</em>
            </td>
          </tr>
          <tr>
            <td
              style="width: 110px"
              valign="top"
              class="py-1 font-size-18 text-capitalize font-weight-500"
            >
              Full name
            </td>
            <td valign="top" class="py-1 font-size-18 text-capitalize">
              <template v-if="getFullName">
                {{ getFullName }}
              </template>
              <em v-else class="text-muted">no Full name</em>
            </td>
          </tr>
          <tr>
            <td
              valign="top"
              class="py-1 font-size-18 text-capitalize font-weight-500"
            >
              Designation
            </td>
            <td valign="top" class="py-1 font-size-18 text-capitalize">
              <v-chip
                v-if="getDesignation"
                color="cyan"
                class="my-1 mr-1"
                outlined
                label
                small
              >
                {{ getDesignation }}
              </v-chip>
              <em v-else class="text-muted">no Designation</em>
            </td>
          </tr>
          <tr>
            <td
              valign="top"
              class="py-1 font-size-18 text-capitalize font-weight-500"
            >
              Role
            </td>
            <td valign="top" class="py-1 font-size-18 text-capitalize">
              <template v-if="getRole">
                {{ getRole }}
              </template>
              <em v-else class="text-muted">no Role</em>
            </td>
          </tr>
          <!-- <tr>
            <td class="py-1 font-size-18 font-weight-500 text-capitalize">Skills</td>
            <td class="py-1 font-size-18 text-capitalize">
              <template
                v-if="Array.isArray(engineer.skills) && engineer.skills.length"
              >
                <v-chip
                  v-for="skill in engineer.skills"
                  :key="skill"
                  color="chip-custom-blue"
                  class="my-1 mr-1"
                  outlined
                  label
                  small
                >
                  {{ skill }}
                </v-chip>
              </template>
            </td>
          </tr> -->
          <tr>
            <td
              valign="top"
              class="py-1 font-size-18 font-weight-500 text-capitalize"
            >
              Email
            </td>
            <td valign="top" class="py-1 font-size-18 text-lowercase">
              <template v-if="getEmail">
                {{ getEmail }}
              </template>
              <em v-else class="text-muted">no Email</em>
            </td>
          </tr>
          <tr>
            <td
              valign="top"
              class="py-1 font-size-18 font-weight-500 text-capitalize"
            >
              Phone No
            </td>
            <td valign="top" class="py-1 font-size-18 text-lowercase">
              <template v-if="getMobile">
                {{ getMobile }}
              </template>
              <em v-else class="text-muted">no Phone No</em>
            </td>
          </tr>
          <tr v-if="getProbationStart">
            <th
              colspan="2"
              class="grey lighten-4 font-size-19 color-custom-blue py-1"
            >
              Probation
            </th>
          </tr>
          <tr v-if="getProbationStart">
            <td
              valign="top"
              class="py-1 font-size-18 font-weight-500 text-capitalize"
            >
              Start Date
            </td>
            <td valign="top" class="py-1 font-size-18 text-lowercase">
              <template v-if="getProbationStart">
                {{ formatDate(getProbationStart) }}
              </template>
              <em v-else class="text-muted">no Start Date</em>
            </td>
          </tr>
          <tr v-if="getProbationStart">
            <td
              valign="top"
              class="py-1 font-size-18 font-weight-500 text-capitalize"
            >
              End Date
            </td>
            <td valign="top" class="py-1 font-size-18 text-lowercase">
              <template v-if="getProbationEnd">
                {{ formatDate(getProbationEnd) }}
              </template>
              <em v-else class="text-muted">no End Date</em>
            </td>
          </tr>
          <tr>
            <td
              valign="top"
              class="py-1 font-size-18 font-weight-500 text-capitalize"
            >
              Login
            </td>
            <td valign="top" class="py-1 font-size-18 text-capitalize">
              <v-chip
                v-if="getAllowLogin"
                :color="getAllowLogin == 'YES' ? 'green' : 'red'"
                class="my-1 mr-1"
                outlined
                label
                small
              >
                {{ getAllowLogin }}
              </v-chip>
              <em v-else class="text-muted">no Login</em>
            </td>
          </tr>
          <!-- <tr>
            <td class="font-size-18 text-capitalize">Leave</td>
            <td class="font-size-18 font-weight-600 text-capitalize">
              {{ getAllowLeave }}
            </td>
          </tr> -->
        </table>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import CommonMixin from "@/core/plugins/common-mixin";
import FileManagerMixin from "@/core/lib/file-manager/file.manager.mixin";
import Barcode from "@/view/pages/partials/Barcode.vue";
import { PATCH } from "@/core/services/store/request.module";
import moment from "moment-timezone";
moment.tz.setDefault(process.env.VUE_APP_TIMEZONE);

export default {
  name: "personal-info",
  mixins: [CommonMixin, FileManagerMixin],
  props: {
    engineer: {
      type: Object,
      required: true,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      rawImage: null,
      profileImage: null,
      fieldDescriptions: [
        {
          field: "product_type",
          title: "Product Type",
          description:
            "Select if this item is a physical good or a service you're offering.",
          footer: "Note",
          footer_content:
            "Once you include this items in a transaction, you cannot change its type.",
        },
      ],
    };
  },
  components: {
    Barcode,
  },
  watch: {
    rawImage(param) {
      const _this = this;
      if (_this.lodash.isEmpty(_this.engineer) === false) {
        _this.uploadAttachment(param).then((response) => {
          _this.profileImage = _this.lodash.head(response);
          if (_this.lodash.isEmpty(_this.profileImage) === false) {
            _this.$store
              .dispatch(PATCH, {
                url: "engineer/" + _this.engineer.id,
                data: {
                  profile_logo: _this.profileImage.id,
                  role: _this.engineer.role.id,
                },
              })
              .catch((error) => {
                _this.logError(error);
              });
          }
        });
      }
    },
  },
  methods: {
    selectImage() {
      this.$refs["uploadImage"].$refs["input"].click();
    },
    getProvision() {
      let a = moment();
      let b = moment(this.engineer.probation_start);
      return b.diff(a, "days");
    },
  },
  computed: {
    getProfileImage() {
      const _this = this;
      let result = null;
      if (_this.lodash.isEmpty(_this.profileImage) === false) {
        return _this.profileImage.file.url;
      }
      if (
        _this.lodash.isEmpty(_this.engineer) === false &&
        _this.lodash.isEmpty(_this.engineer.profile_logo) === false &&
        _this.lodash.isEmpty(_this.engineer.profile_logo.file) === false
      ) {
        result = _this.engineer.profile_logo.file.url;
      }
      return result;
    },
    getBarcode() {
      return this.lodash.isEmpty(this.engineer) === false
        ? this.engineer.barcode
        : "";
    },
    getSkills() {
      return this.lodash.isEmpty(this.engineer) === false
        ? this.engineer.skills
          ? this.engineer.skills.join(", ")
          : ""
        : "";
    },
    getRole() {
      return this.lodash.isEmpty(this.engineer.role) === false
        ? this.engineer.role.name
        : "";
    },
    getDesignation() {
      const _this = this;
      let result = null;
      if (_this.lodash.isEmpty(_this.engineer) === false) {
        if (_this.lodash.isEmpty(_this.engineer.designation) === false) {
          result = _this.engineer.designation.text;
        }
      }
      return result;
    },
    getEmail() {
      return this.lodash.isEmpty(this.engineer) === false
        ? this.engineer.primary_email
        : "";
    },
    getMobile() {
      return this.lodash.isEmpty(this.engineer) === false
        ? this.engineer.primary_phone
        : "";
    },
    getProbationStart() {
      return this.lodash.isEmpty(this.engineer) === false
        ? this.engineer.probation_start
        : "no probation start";
    },
    getProbationEnd() {
      return this.lodash.isEmpty(this.engineer) === false
        ? this.engineer.probation_end
        : "no probation start";
    },
    getFullName() {
      return this.lodash.isEmpty(this.engineer) === false
        ? this.engineer.full_name
        : "";
    },
    getAllowLogin() {
      let status = "NO";
      if (this.lodash.isEmpty(this.engineer) === false) {
        if (this.engineer.can_login == 1) {
          status = "YES";
        }
      }
      return status;
    },
    getAllowLeave() {
      let status = "No";
      if (this.lodash.isEmpty(this.engineer) === false) {
        if (this.engineer.allow_leave == 1) {
          status = "Yes";
        }
      }
      return status;
    },
  },
};
</script>
